// import React, { useEffect, useState } from "react";
// import "./history.scss";
// import axiosInstance from "../../../../../httpInterceptor";
// import ColorDisplay from "./ColorPicker";
// import FadeLoader from "react-spinners/FadeLoader";
// import { Box } from "@mui/material";
 
// interface Question {
//   id: number;
//   created_date: string;
//   created_by: string;
//   description: string;
//   response: string;
//   remarks: string;
// }
 
// interface HistoryProps {
//   projectid: string | undefined;
//   set: string | undefined;
//   color: string[]; // Add color prop
// }
// interface QuestionGroup extends Array<Question> { }
// interface AssessmentDetail {
//   assessmentdate: string;
//   projectstatus: string;
//   reasonforchange: string;
//   qnadetails: any[];
//   created_by: string;
//   modified_by: string;
//   created_date: string;
//   modified_date: string;
// }
// interface Project {
//   projectid: string;
//   set_name: string;
//   emailIds: string[];
//   observationCount: number;
//   assessmentdetails: AssessmentDetail[];
// }
// const History: React.FC<HistoryProps> = ({ projectid, set, color }) => {
//   const [questions, setQuestions] = useState<QuestionGroup[]>([]);
//   const [assessmentDetails, setAssessmentDetails] = useState<AssessmentDetail[]>([]);
//   const [isOpen, setIsOpen] = useState<{ [key: number]: boolean }>({});
//   const [errorMessage, setErrorMessage] = useState("");
//   const [project, setProject] = useState<Project | null>(null);
//   const [loading, setLoading] = useState(true);
 
//   useEffect(() => {
//     const getHistoryDetailsByProjectId = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axiosInstance.get(
//           `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/get-projectassesment/${projectid}/${set}`
//         );
 
//         if (!data || data.length === 0) {
//           setQuestions([]);
//           setAssessmentDetails([]);
//           setLoading(false);
//           return setErrorMessage(
//             "History will be shown once the assessment is completed"
//           );
//         }
 
//         const groupedQuestions = [];
//         const sortedAssessments: AssessmentDetail[] = [];
 
//         for (const result of data) {
//           const assessments = result.assessmentdetails || [];
 
//           // Sort by created_date descending
//           assessments.sort(
//             (a: AssessmentDetail, b: AssessmentDetail) =>
//               new Date(b.created_date).getTime() -
//               new Date(a.created_date).getTime()
//           );
 
//           for (const detail of assessments) {
//             sortedAssessments.push(detail);
//             const qnaDetails = detail.qnadetails || [];
//             const questionGroup = [];
 
//             for (const item of qnaDetails) {
//               const questionRes = await axiosInstance.get(
//                 `${process.env.REACT_APP_QUESTION_SERVICE_BASE_URL}/questions/${item.questionid}`
//               );
 
//               questionGroup.push({
//                 id: item.questionid,
//                 created_date: detail.created_date,
//                 created_by: detail.created_by,
//                 description: questionRes.data.description,
//                 response: item.response,
//                 remarks: item.remarks,
//               });
//             }
 
//             groupedQuestions.push(questionGroup);
//           }
//         }
 
//         if (groupedQuestions.length > 0) {
//           setQuestions(groupedQuestions); // array of arrays
//           setAssessmentDetails(sortedAssessments); // store sorted assessment details
//         } else {
//           setQuestions([]);
//           setAssessmentDetails([]);
//           setErrorMessage(
//             "History will be shown once the assessment is completed"
//           );
//         }
//       } catch (error) {
//         console.error("Error fetching history:", error);
//         setQuestions([]);
//         setAssessmentDetails([]);
//         setErrorMessage("An error occurred while fetching history.");
//       } finally {
//         setLoading(false);
//       }
//     };
 
//     const fetchProjectStatus = async () => {
//       try {
//         const response = await axiosInstance.get(
//           `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/get-projectassesment/${projectid}/${set}`
//         );

//         const projectData = response.data[0];

//         // Fetch observation count
//         const obsResponse = await axiosInstance.get(
//           `${process.env.REACT_APP_OBSERVATION_SERVICE_BASE_URL}/observationcount/${projectid}/${set}`
//         );

//         const observationCount = obsResponse.data?.observationCount || 0;

//         // Merge observation count into project data
//         setProject({ ...projectData, observationCount });

//       } catch (error) {
//         console.error("Error fetching project data:", error);
//       }
//     };
 
//     getHistoryDetailsByProjectId();
//     fetchProjectStatus();
//   }, [projectid, set]);
 
//   const handleOpenClose = (index: number) => {
//     setIsOpen((prev) => ({ ...prev, [index]: !prev[index] }));
//   };
 
//   const formatDate = (dateString: string) => {
//     const date = new Date(dateString);
//     const day = date.getDate();
//     const month = date.toLocaleString("default", { month: "long" });
//     const year = date.getFullYear();
//     return `${day}th ${month}, ${year}`;
//   };
//   return loading ? (
//      <Box
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: 60,
//         width: "100%",
//       }}
//     >
//       <span
//         style={{
//           display: "flex",
//           alignItems: "center",
//           color: "#074173",
//           fontWeight: 500,  
//         }}
//       >
//         Please wait while fetching the history data
//         <span
//           style={{
//             marginLeft: 12,
//             translate: "3px 6px",          
//           }}
//         >
//           <FadeLoader
//             color="#074173"
//             height={8}
//             width={3}
//             radius={1}
//             margin={-6}
//             speedMultiplier={3}
//           />
//         </span>
//       </span>
//     </Box>
//   ) : (
//     <div className="history">
//       <div className="historySearchInputBox"></div>
//       <div className="historyBodyContainer">
//         {questions.length > 0 ? (
//           questions.map((questionGroup, index) => (
//             <div key={index}>
//               <div
//                 className="historyBtn"
//                 onClick={() => handleOpenClose(index)}
//                 style={{ backgroundColor: index % 2 !== 0 ? "#ddd" : "white" }}
//               >
//                 <p style={{ color: " #074173" }}>
//                   {assessmentDetails[index]
//                     ? formatDate(assessmentDetails[index].created_date)
//                     : "No Date"}
//                 </p>
//                 <div style={{ translate: "800px", position: "absolute" }}>
//                   <p
//                     style={{
//                       color: " #074173",
//                       right: "70%",
//                       position: "relative",
//                     }}
//                   >
//                     Submitted by {assessmentDetails[index]?.created_by || "Unknown"}
//                   </p>
//                   {!isOpen[index] ? (
//                     <i
//                       className="fa-solid fa-chevron-right"
//                       style={{ translate: "200px 9px", color: " #074173" }}
//                     >
//                       {" "}
//                     </i>
//                   ) : (
//                     <i
//                       className="fa-solid fa-chevron-down"
//                       style={{ translate: "200px 9px", color: "#074173" }}
//                     ></i>
//                   )}
//                 </div>
//                 {project &&
//                   project.assessmentdetails &&
//                   project.assessmentdetails.slice().reverse()[index] && (
//                     <div
//                       style={{
//                         transform: "translate(1150px, 5px)",
//                         position: "absolute",
//                       }}
//                     >
//                       <ColorDisplay
//                         color={
//                           project.assessmentdetails
//                             .slice()
//                             .reverse()[index]?.projectstatus === ""
//                             ? project.assessmentdetails
//                                 .slice()
//                                 .reverse()[index + 1]?.projectstatus ?? "NA"
//                             : project.assessmentdetails
//                                 .slice()
//                                 .reverse()[index]?.projectstatus ?? "NA"
//                         }
//                       />

//                       <div
//                         style={{
//                           marginTop: "5px",
//                           fontSize: "17px",
//                           color: "#074173",
//                           position: "relative",
//                           right: "100%",
//                           transform: "translate(-520px, -10px)"
//                         }}
//                       >
//                         <p style={{ marginRight: "5px", marginBottom: "2px", color: "#074173" }}>Assessment Type:</p>
//                         {
//                           project.set_name
//                         }
//                       </div>
//                        <div
//                         style={{
//                           marginTop: "5px",
//                           fontSize: "17px",
//                           color: "#074173",
//                           position: "relative",
//                           right: "100%",
//                           transform: "translate(-40px, -10px)"
//                         }}
//                       >
//                       <p style={{ color: "#074173" }}>
//                         # of Findings: {project?.observationCount || 0}
//                       </p>
//                       </div>

//                     </div>
//                   )}
//               </div>
//               {isOpen[index] && (
//                 <div>
//                   <table className="historyTable">
//                     <thead>
//                       <tr>
//                         <td style={{ color: "black" }}>#</td>
//                         <td style={{ color: "black" }}>Questions</td>
//                         <td style={{ color: "black" }}>Response</td>
//                         <td style={{ color: "black" }}>Remarks</td>
//                       </tr>
//                     </thead>
//                     <tbody className="assessmentBody">
//                       {questionGroup.map((item, idx) => (
//                         <tr key={idx}>
//                           <td style={{ width: "10%" }}>{idx + 1}</td>
//                           <td>{item.description}</td>
//                           <td>
//                             {item.response}
//                           </td>
//                           <td style={{ width: "30%" }}>
//                             {item.remarks}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           ))
//         ) : (
//           <h2 className="errorMessage">{errorMessage}</h2>
//         )}
//       </div>
//     </div>
//   );
// };
 
// export default History;
 
 
import React, { useEffect, useState } from "react";
import "./history.scss";
import axiosInstance from "../../../../../httpInterceptor";
import ColorDisplay from "./ColorPicker";
import FadeLoader from "react-spinners/FadeLoader";
import { Box, Tooltip } from "@mui/material";

 
interface Question {
  id: number;
  created_date: string;
  created_by: string;
  description: string;
  response: string;
  remarks: string;
  assessmentId?: string;
}
 
interface HistoryProps {
  projectid: string | undefined;
  set: string | undefined;
  color: string[]; // Add color prop
}
interface QuestionGroup extends Array<Question> { }
interface AssessmentDetail {
  assessmentdate: string;
  projectstatus: string;
  reasonforchange: string;
  qnadetails: any[];
  created_by: string;
  modified_by: string;
  created_date: string;
  modified_date: string;
}
interface Project {
  projectid: string;
  set_name: string;
  emailIds: string[];
  observationCount: number;
  assessmentdetails: AssessmentDetail[];
}
type SortField = 'date' | 'health' | 'submittedBy' | 'type' | 'findings';
type SortOrder = 'asc' | 'desc' | null;

const History: React.FC<HistoryProps> = ({ projectid, set, color }) => {
  const [questions, setQuestions] = useState<QuestionGroup[]>([]);
  const [isOpen, setIsOpen] = useState<{ [key: number]: boolean }>({});
  const [errorMessage, setErrorMessage] = useState("");
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);
  const [pdfAvailability, setPdfAvailability] = useState<{ [key: string]: boolean }>({});
  const [sortField, setSortField] = useState<SortField | null>(null);
  const [sortOrder, setSortOrder] = useState<SortOrder>(null);
  const [originalQuestions, setOriginalQuestions] = useState<QuestionGroup[]>([]);
  const [originalAssessments, setOriginalAssessments] = useState<AssessmentDetail[]>([]);
 
  useEffect(() => {
    const getHistoryDetailsByProjectId = async () => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get(
          `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/get-projectassesment/${projectid}/${set}`
        );
 
        if (!data || data.length === 0) {
          setQuestions([]);
          setLoading(false);
          return setErrorMessage(
            "History will be shown once the assessment is completed"
          );
        }
 
        // Fetch all questions for the set once
        const questionsResponse = await axiosInstance.get(
          `${process.env.REACT_APP_QUESTION_SERVICE_BASE_URL}/questions-by-set/${set}`
        );
        
        // Create a map for quick lookup by question ID
        const questionsMap: { [key: string]: any } = {};
        questionsResponse.data.forEach((question: any) => {
          questionsMap[question._id] = question;
        });
 
        const groupedQuestions = [];
        const pdfAvailabilityMap: { [key: string]: boolean } = {};
 
        for (const result of data) {
          const assessments = result.assessmentdetails || [];
 
          // Sort by created_date descending
          assessments.sort(
            (a: AssessmentDetail, b: AssessmentDetail) =>
              new Date(b.created_date).getTime() -
              new Date(a.created_date).getTime()
          );
 
          for (const detail of assessments) {
            const qnaDetails = detail.qnadetails || [];
            const questionGroup = [];
 
            for (const item of qnaDetails) {
              const questionData = questionsMap[item.questionid];

              questionGroup.push({
                id: item.questionid,
                created_date: detail.created_date,
                created_by: detail.created_by,
                description: questionData?.description || "Question not found",
                response: item.response,
                remarks: item.remarks,
                assessmentId: detail._id,
              });
            }
 
            groupedQuestions.push(questionGroup);
            
            // Check PDF availability for this assessment
            try {
              const pdfResponse = await axiosInstance.get(
                `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/report/url/${projectid}/${set}/${detail._id}`
              );
              pdfAvailabilityMap[detail._id] = !!(pdfResponse.data && pdfResponse.data.url);
            } catch (error) {
              pdfAvailabilityMap[detail._id] = false;
            }
          }
        }
 
        setPdfAvailability(pdfAvailabilityMap);
        if (groupedQuestions.length > 0) {
          setQuestions(groupedQuestions); // array of arrays
          setOriginalQuestions(groupedQuestions); // store original order
        } else {
          setQuestions([]);
          setOriginalQuestions([]);
          setErrorMessage(
            "History will be shown once the assessment is completed"
          );
        }
      } catch (error) {
        console.error("Error fetching history:", error);
        setQuestions([]);
        setErrorMessage("An error occurred while fetching history.");
      } finally {
        setLoading(false);
      }
    };
 
    const fetchProjectStatus = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL}/get-projectassesment/${projectid}/${set}`
        );
 
        const projectData = response.data[0];
 
        // Fetch observation count
        const obsResponse = await axiosInstance.get(
          `${process.env.REACT_APP_OBSERVATION_SERVICE_BASE_URL}/observationcount/${projectid}/${set}`
        );
 
        const observationCount = obsResponse.data?.observationCount || 0;
 
        // Merge observation count into project data
        setProject({ ...projectData, observationCount });
        
        // Store original assessment details
        if (projectData.assessmentdetails) {
          setOriginalAssessments(projectData.assessmentdetails);
        }
      } catch (error) {
        console.error("Error fetching project data:", error);
      }
    };
 
    getHistoryDetailsByProjectId();
    fetchProjectStatus();
  }, [projectid, set]);
 
  const handleOpenClose = (index: number) => {
    setIsOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };
 
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    
    // Determine the correct suffix for the day
    let suffix = "th";
    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }
    
    // Format time as HH:MMpm/am
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const timeString = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}${ampm}`;
    
    return `${day}${suffix} ${month}, ${year}`;
  };

  const handleSort = (field: SortField) => {
    let newSortOrder: SortOrder;
    
    if (sortField === field) {
      // Cycle through: asc -> desc -> null (original order)
      if (sortOrder === 'asc') {
        newSortOrder = 'desc';
      } else if (sortOrder === 'desc') {
        newSortOrder = null;
      } else {
        newSortOrder = 'asc';
      }
    } else {
      newSortOrder = 'asc';
    }

    setSortField(newSortOrder === null ? null : field);
    setSortOrder(newSortOrder);

    if (newSortOrder === null) {
      // Reset to original order
      setQuestions([...originalQuestions]);
      if (project && originalAssessments.length > 0) {
        setProject({ ...project, assessmentdetails: [...originalAssessments] });
      }
      return;
    }

    // Create a copy of questions array with index mapping
    const questionsWithIndex = questions.map((q, idx) => ({ q, idx }));

    questionsWithIndex.sort((a, b) => {
      let comparison = 0;
      const reversedIndex = questions.length - 1;

      switch (field) {
        case 'date':
          const dateA = new Date(a.q[0]?.created_date || 0).getTime();
          const dateB = new Date(b.q[0]?.created_date || 0).getTime();
          comparison = dateA - dateB;
          break;

        case 'health':
          if (project?.assessmentdetails) {
            const healthA = project.assessmentdetails.slice().reverse()[a.idx]?.projectstatus || '';
            const healthB = project.assessmentdetails.slice().reverse()[b.idx]?.projectstatus || '';
            comparison = healthA.localeCompare(healthB);
          }
          break;

        case 'submittedBy':
          const submittedByA = a.q[0]?.created_by || '';
          const submittedByB = b.q[0]?.created_by || '';
          comparison = submittedByA.localeCompare(submittedByB);
          break;

        case 'type':
          const typeA = project?.set_name || '';
          const typeB = project?.set_name || '';
          comparison = typeA.localeCompare(typeB);
          break;

        case 'findings':
          const findingsA = project?.observationCount || 0;
          const findingsB = project?.observationCount || 0;
          comparison = findingsA - findingsB;
          break;
      }

      return newSortOrder === 'asc' ? comparison : -comparison;
    });

    const sortedQuestions = questionsWithIndex.map(item => item.q);
    setQuestions(sortedQuestions);

    // Update project assessment details to match sorted order
    if (project?.assessmentdetails) {
      const reversedAssessments = project.assessmentdetails.slice().reverse();
      const sortedAssessments = questionsWithIndex.map(item => reversedAssessments[item.idx]);
      setProject({ ...project, assessmentdetails: sortedAssessments.reverse() });
    }
  };

  const getSortIcon = (field: SortField) => {
    if (sortField !== field) {
      return <i className="fa-solid fa-sort" style={{ marginLeft: '8px', color: '#555', opacity: 0.5 }}></i>;
    }
    if (sortOrder === 'asc') {
      return <i className="fa-solid fa-sort-up" style={{ marginLeft: '8px', color: '#FF5E4F' }}></i>;
    }
    if (sortOrder === 'desc') {
      return <i className="fa-solid fa-sort-down" style={{ marginLeft: '8px', color: '#FF5E4F' }}></i>;
    }
    return <i className="fa-solid fa-sort" style={{ marginLeft: '8px', color: '#555', opacity: 0.5 }}></i>;
  };

  const handlePdfClick = async (e: React.MouseEvent, createdBy: string, createdDate: string, assessmentId: string) => {
    e.stopPropagation();
    
    // Check if PDF is available
    if (!pdfAvailability[assessmentId]) {
      return;
    }
    
    try {
      // Now fetch the PDF URL using the assessment_id
      const pdfResponse = await axiosInstance.get(
        `${process.env.REACT_APP_LLM_SERVICE_BASE_URL}/report/url/${projectid}/${set}/${assessmentId}`
      );

      if (pdfResponse.data && pdfResponse.data.url) {
        window.open(pdfResponse.data.url, '_blank');
      } else {
        alert("PDF URL not found for this assessment");
      }
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
      alert("Failed to load PDF. Please try again.");
    }
  };

  return loading ? (
     <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 60,
        width: "100%",
      }}
    >
      <span
        style={{
          display: "flex",
          alignItems: "center",
          color: "#FF5E4F",
          fontWeight: 500,  
        }}
      >
        Please wait while fetching the history data
        <span
          style={{
            marginLeft: 12,
            translate: "3px 6px",          
          }}
        >
          <FadeLoader
            color="#FF5E4F"
            height={8}
            width={3}
            radius={1}
            margin={-6}
            speedMultiplier={3}
          />
        </span>
      </span>
    </Box>
  ) : (
    <div className="history">
      {/* <div className="historySearchInputBox"></div> */}
      <div className="historyBodyContainer">
        {questions.length > 0 ? (
          <>
            <div className="historyTableHeader">
              <div className="header-cell date-header sortable" onClick={() => handleSort('date')}>
                Assessment Date
                {getSortIcon('date')}
              </div>
              <div className="header-cell health-header sortable" onClick={() => handleSort('health')}>
                Health
                {getSortIcon('health')}
              </div>
              <div className="header-cell submittedby-header sortable" onClick={() => handleSort('submittedBy')}>
                Submitted By
                {getSortIcon('submittedBy')}
              </div>
              <div className="header-cell type-header sortable" onClick={() => handleSort('type')}>
                Assessment Type
                {getSortIcon('type')}
              </div>
              <div className="header-cell findings-header sortable" onClick={() => handleSort('findings')}>
                Findings Count
                {getSortIcon('findings')}
              </div>
              <div className="header-cell pdf-header">Assessment Report</div>
              <div className="header-cell action-header">Action</div>
            </div>
            {questions.map((questionGroup, index) => (
            <div key={index}>
              <div
                className="historyBtn"
                style={{ backgroundColor: index % 2 !== 0 ? "#ddd" : "white", position: "relative" }}
              >
                <div className="history-row">
                  <div className="row-cell date-cell">
                    <p style={{ color: "black", margin: 0 }}>
                      {questionGroup[0]
                        ? formatDate(questionGroup[0].created_date)
                        : "No Date"}
                    </p>
                  </div>

                  <div className="row-cell health-cell">
                    {project &&
                      project.assessmentdetails &&
                      project.assessmentdetails.slice().reverse()[index] && (
                        <ColorDisplay
                          color={
                            project.assessmentdetails.slice().reverse()[index]
                              .projectstatus === ""
                              ? project.assessmentdetails.slice().reverse()[
                                index + 1
                              ]?.projectstatus ?? "NA"
                              : project.assessmentdetails.slice().reverse()[index]
                                .projectstatus
                          }
                        />
                      )}
                  </div>

                  <div className="row-cell submittedby-cell">
                    <p style={{ color: "black", margin: 0 }}>
                      {questionGroup[0]?.created_by || "Unknown"}
                    </p>
                  </div>

                  <div className="row-cell type-cell">
                    <p style={{ color: "black", margin: 0 }}>
                      {project?.set_name || ""}
                    </p>
                  </div>

                  <div className="row-cell findings-cell">
                    <p style={{ color: "black", margin: 0 }}>
                      {project?.observationCount || 0}
                    </p>
                  </div>

                  <div className="row-cell pdf-cell">
                    <div
                      style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        cursor: pdfAvailability[questionGroup[0]?.assessmentId || ""] ? "pointer" : "not-allowed",
                        opacity: pdfAvailability[questionGroup[0]?.assessmentId || ""] ? 1 : 0.5,
                        userSelect: "none"
                      }}
                      title={pdfAvailability[questionGroup[0]?.assessmentId || ""] ? "View Assessment PDF" : "PDF is not available"}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (pdfAvailability[questionGroup[0]?.assessmentId || ""]) {
                          handlePdfClick(e, questionGroup[0]?.created_by || "", questionGroup[0]?.created_date || "", questionGroup[0]?.assessmentId || "");
                        }
                      }}
                    >
                      <i
                        className="fa-solid fa-file-pdf"
                        style={{ 
                          color: "#332929ff",
                          fontSize: "24px",
                          pointerEvents: "none"
                        }}
                      />
                    </div>
                  </div>

                  <div className="row-cell action-cell">
                    <Tooltip title={isOpen[index] ? "Collapse" : "Expand"} arrow>
                      <span style={{ display: "inline-flex" }}>
                        {!isOpen[index] ? (
                          <i
                            className="fa-solid fa-chevron-right"
                            style={{ color: "black", fontSize: "16px", cursor: "pointer" }}
                            onClick={() => handleOpenClose(index)}
                          />
                        ) : (
                          <i
                            className="fa-solid fa-chevron-down"
                            style={{ color: "black", fontSize: "16px", cursor: "pointer" }}
                            onClick={() => handleOpenClose(index)}
                          />
                        )}
                      </span>
                    </Tooltip>
                  </div>
                </div>
              </div>
              {isOpen[index] && (
                <div>
                  <table className="historyTable">
                    <thead>
                      <tr>
                        <td style={{ color: "black" }}>#</td>
                        <td style={{ color: "black" }}>Questions</td>
                        <td style={{ color: "black" }}>Response</td>
                        <td style={{ color: "black" }}>Remarks</td>
                      </tr>
                    </thead>
                    <tbody className="assessmentBody">
                      {questionGroup.map((item, idx) => (
                        <tr key={idx}>
                          <td style={{ width: "10%" }}>{idx + 1}</td>
                          <td>{item.description}</td>
                          <td>
                            {item.response}
                          </td>
                          <td style={{ width: "30%", translate: "14px" }}>
                            {item.remarks}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
          </>
        ) : (
          <h2 className="errorMessage">{errorMessage}</h2>
        )}
      </div>
    </div>
  );
};
 
export default History;
 